import dayjs from 'dayjs';
import useFetchedData from 'hooks/useFetchedData';
import { useContext, useEffect, useState } from 'react';
import { CartContext } from 'constants/contexts';
import { EMPTY_ARRAY, env } from 'constants';
import { menuTransformer } from './Menus/utils';
import useMerchantIdOrSlug from '../../hooks/useMerchantIdOrSlug';

function useMenus() {
  const cart = useContext(CartContext);
  const [openingHours, setOpeningHours] = useState(null);
  const idOrSlug = useMerchantIdOrSlug();

  useEffect(() => {
    setOpeningHours([]);
  }, [idOrSlug]);

  function getScheduleTime() {
    if (!env.IS_CATERING && cart.scheduledTime) {
      return dayjs(cart.scheduledTime).toISOString();
    }
  }
  // eslint-disable-next-line prefer-const
  const {
    data: menus = EMPTY_ARRAY, loading, error, ...rest
  } = useFetchedData(
    idOrSlug && {
      url: `v1/restaurants/${idOrSlug}/menus/`,
      query: {
        active: 'True',
        skip_modifiers: 'True',
        scheduled_datetime: getScheduleTime(),
      },
    },
    ({ results } = {}) => results?.map(menuTransformer),
  );

  useEffect(() => {
    if (
      error &&
      error.response?.data?.title === 'RestaurantNotAvailableException'
    ) {
      const { meta } = error.response.data;
      setOpeningHours(meta.schedule);
    }
  }, [error, cart.scheduledTime]);

  const { data: onSaleList } = useFetchedData(
    idOrSlug && {
      url: `v1/restaurants/${idOrSlug}/featured-lists/`,
      query: {
        query:
        '{id,name,image,images{image_small},sizes,discount,is_active,restaurant}',
      },
    },
    ({ data = [] } = {}) => data.filter((l) => l.slug === 'on_sale' && l.items.length > 0).map(({ label, ...l }) => ({
      ...l,
      name: label,
    })),
  );

  return {
    loading,
    menus,
    onSaleList,
    openingHours,
  };
}

export default useMenus;
